import { render, staticRenderFns } from "./snp_gene.vue?vue&type=template&id=0267fd26&scoped=true&"
import script from "./snp_gene.vue?vue&type=script&lang=js&"
export * from "./snp_gene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0267fd26",
  null
  
)

export default component.exports